export const SET_ARTWORKS = 'SET_ARTWORKS'
export const SET_ARTWORK_LOADING = 'SET_LOADING'
export const SET_ARTWORK_ERROR = 'SET_ARTWORK_ERROR'
export const SET_SINGLE_ARTWORK = 'SET_SINGLE_ARTWORK'

export const ADD_FAVORITE = 'ADD_FAVORITE'
export const SET_FAVORITE_LOADING = 'SET_FAVORITE_LOADING'
export const SET_FAVORITE_ERROR = 'SET_FAVORITE_ERROR' 